import LangPicker from './LangPicker'
import './locales'

export default LangPicker
